<template>
  <html>
    <head> </head>
    <body>
      <navbar></navbar>

      <!--img
        id="header-s"
        src="https://media.ourgreen.co.th/wp-content/uploads/2021/06/Loyalty-hub-header-l.png"
      /-->
      <div class="contra header-banner" style="text-align:center;">
        <div class="title-page-l">
         <img
          class="icon-title"
          src="https://media.ourgreen.co.th/wp-content/uploads/2021/06/loyalty-hub-icon-point.png"
        />
          <p>คะเเนนสะสม</p>
          <h1>{{ info.point  | numFormat('0,000,000') }}</h1>
        </div>

        <div class="edit-b">
          <!-- </div>

        <div class="title-page-r"> -->
          <a @click="goto('EditProfile')"> <p style="text-align: center;padding-top: 12px; padding-right: 10px;">Edit</p> </a>
        </div>

        <div class="row bg-white-edit-p">
          <div>
            <div class="img-profile">
              <img :src="lineInfo.pictureUrl" />
            </div>
            <span class="name-profile">{{ info.firstname + " " + info.lastname }}</span>
            </div>
          <div class="container-fluid row-t bg-white-edit-p-form overflow-auto" v-if="info._id">
            <div
              id="lh-form"
              class="row-t"
              style="padding: 5px;"
            >
              <form method="post">
                 <div class="form-group">
                  <label for="birthdate" class="text-form">วันเกิด *</label>
                  <p>{{ birthdate }}</p>
                  <!-- <date-picker
                    v-model="info.birthdate"
                    class="form-control"
                    style="width: 100%; border: 0"
                    valueType="format"
                  ></date-picker> -->
                </div>
                <!--div class="form-group">
                  <label for="genders" class="text-form">เพศ *</label>
                  <p>{{ gender(info.genders) }}</p>
                </div-->
                <div class="form-group">
                  <label for="phone" class="text-form">เบอร์โทรศัพท์มือถือ *</label>
                  <!-- <input
                    type="number"
                    class="form-control"
                    id="phone"
                    placeholder="0899999999"
                    v-model="info.phone"
                    maxlength="10"
                    aria-readonly="readonly"
                    readonly="readonly"
                  /> -->
                  <p>{{ info.phone }}</p>
                </div>
                <div class="form-group">
                  <label for="email" class="text-form">อีเมล *</label>
                  <!-- <input
                    type="email"
                    class="form-control"
                    id="email"
                    placeholder="youremail@email.com"
                    required
                    v-model="info.email"
                    aria-readonly="readonly"
                    readonly="readonly"
                  /> -->
                  <p>{{ info.email }}</p>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div class="row bt " style="margin-top: 50px;">
          <a @click="showModal" class="btn btn-accept light-color font-color btn-lg btn-block qr-bt"
            >คิวอาร์โค้ดของฉัน</a
          >
        </div>
      </div>
      <div style="margin-bottom: 200px"></div>
      <modal name="qrCode" width="80%">
        <!--member-qrcode v-bind:info="info" v-if="info._id"></!--member-qrcode-->
        
        <span style="
    text-align: center;
    display: block;
    color: white;
    padding-top: 5px;
    padding-bottom: 5px;margin-top: -17px;" class="dark-color">คิวอาร์โค้ดของฉัน</span>
        <div class="qrModal">
          <div class="qr"><qr-code :text="info._id" size="200"></qr-code></div>
        </div>
        <div class="memberId">PHONE : {{ info.phone }}</div>
        <div style="margin-bottom:0">
          <span @click="hideModal"  class="dark-color" style="
            text-align: center;
            display: block;
            color: white;
            padding-top: 5px;
            padding-bottom: 5px;
            margin-bottom: -10px;
        ">ปิด</span>
        </div>
      </modal>
    </body>
  </html>
</template>
<script>
//import memberQrCode from "./QRCODE";
import VueQRCodeComponent from "vue-qrcode-component";
import Navbar from "./navbar";
import { DateTimeFunc } from "../libs/constant.js";
export default {
  name: "Profile01",

  components: {
    navbar: Navbar,
    //"member-qrcode": memberQrCode,
    "qr-code": VueQRCodeComponent,
  },
  filters:{
    thDate: function (val) {
      if(val !== undefined){
      let ymd = val.substring(0, 10).split("-");
     
      let month = DateTimeFunc.TH_MONTH(ymd[1]);
      //if(sixHr){
      //  return '<span color="red">'+ymd[2] + " " + month + " " + (parseInt(ymd[0]) + 543)+' '+val.substring(11, 19)+'</span>';
      //}else{
        return ymd[2] + " " + month + " " + (parseInt(ymd[0]) + 543);
      //}
      }else{
      return "";
     }
    },
  },
  data() {
    return {
      // info: {},
      // lineInfo: {},
      size: 200,
    };
  },
  methods: {
    gender(_gender) {
      let res;
      switch (_gender) {
        case "M":
          res = "ชาย";
          break;
        case "F":
          res = "หญิง";
          break;
        default:
          res = "ไม่ระบุ";
          break;
      }
      return res;
    },
    goto(page) {
      console.log(page);
      this.$router.push({
        name: page,
        /*query: {
          apiKey: localStorage.getItem("apiKey"),
          custId: localStorage.getItem("custId"),
        },*/
      });
    },
    hideModal(){
      this.$modal.hide("qrCode");
    },
    showModal() {
      this.$modal.show("qrCode");
    },
  },
  computed: {
    info() {
      return this.$store.state.profile;
    },
    lineInfo() {
      return this.$store.state.lineInfo;
    },
    birthdate() {
      let ymd = this.$store.state.profile.birthdate.substring(0, 10).split("-");
      //alert(ymd);
      //alert(TH_DATE);
      let month = DateTimeFunc.TH_MONTH(ymd[1]);
      return ymd[2] + " " + month + " " + (parseInt(ymd[0]) + 543);
    },
  },
  mounted() {
    console.log(this.$store.state.profile);
    // this.lineInfo = this.$store.state.lineInfo;
    //alert(JSON.stringify(this.$store.state.lineInfo))
    this.$store.dispatch("redeemHistory", {
      apiKey: localStorage.getItem("apiKey"),
      custId: localStorage.getItem("custId"),
      id: this.$store.state.profile._id,
    });
  },
};
</script>
<style scoped>
@import "./Css/style.css";
.contra {
  padding-right: 15px;
}
@media (min-width: 768px) {
  .container {
    width: 750px;
  }
}
@media (min-width: 992px) {
  .container {
    width: 970px;
  }
}
@media (min-width: 1200px) {
  .container {
    width: 1170px;
  }
}
.name-profile {
  font-family: 'Prompt';
  color: #231f20;
  padding: 0px 0px 0px 7px;
  font-weight: 600;
}
.vm--modal {
  padding: 17px 0px 0px 0px !important;
}
.contra {
    padding-right: 15px;
    padding-left: 15px;
}
.bt {
  top: 20px;
  border-radius: 10px;

  position: relative;
  overflow: visible;
}

.footer {
  margin-bottom: 200px;
}
.text-center {
  text-align: center;
}

.qrModal {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
.qr > img {
  text-align: center;
  display: inline-block;
  padding-left: auto;
  padding-right: auto;
}

form {
  background-color: white;
  margin-top: 10px!important;
}
.form-group p {
    text-align: right;
    margin-top: -31px;
}
.text-form {
    font-size: 16px;
    color: #231F20;
    border-left: 4px solid #7bc79a;
    padding-left: 10px;
    height: 25px;
}
</style>
